export { default } from './Mockup'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Mockup/index.js